var _rect, _path, _line, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 102.512 52.39583333333333",
    width: 102.512,
    height: 52.39583333333333,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    stroke: "#ead017",
    strokeWidth: 3,
    width: 99.512,
    height: 49.39583333333333,
    x: 1.5,
    y: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillRule: "nonzero",
    d: "M5.21 20.98Q2.50 20.98 1.25 19.55Q0 18.12 0 15.19L0 15.19L0 13.03L4.22 13.03L4.22 15.19Q4.22 16.13 4.46 16.64Q4.70 17.16 5.42 17.16L5.42 17.16Q5.93 17.16 6.16 16.80Q6.38 16.44 6.43 15.95Q6.48 15.46 6.48 14.52L6.48 14.52L6.48 14.02Q6.48 11.35 4.73 11.35L4.73 11.35Q4.42 11.35 4.32 11.38L4.32 11.38L4.32 7.68Q5.42 7.68 5.98 7.19Q6.53 6.70 6.53 5.62L6.53 5.62Q6.53 3.86 5.52 3.86L5.52 3.86Q4.90 3.86 4.72 4.18Q4.54 4.49 4.48 4.97Q4.42 5.45 4.39 5.66L4.39 5.66L4.39 6.29L0.12 6.29L0.10 5.57Q0.12 2.74 1.44 1.40Q2.76 0.07 5.50 0.07L5.50 0.07Q10.75 0.07 10.75 5.57L10.75 5.57Q10.75 7.18 10.32 8.12Q9.89 9.07 8.83 9.46L8.83 9.46Q9.70 9.89 10.12 10.52Q10.54 11.16 10.67 12.07Q10.80 12.98 10.80 14.52L10.80 14.52Q10.80 17.71 9.47 19.34Q8.14 20.98 5.21 20.98L5.21 20.98ZM15.70 20.93Q14.16 20.93 13.38 20.20Q12.60 19.46 12.35 18.25Q12.10 17.04 12.10 15.14L12.10 15.14L12.14 7.22Q12.14 5.35 13.09 4.16Q14.04 2.98 15.77 2.98L15.77 2.98Q17.47 2.98 18.31 4.10L18.31 4.10L18.31 0L22.51 0L22.51 20.74L18.31 20.74L18.31 18.86Q17.95 19.90 17.34 20.41Q16.73 20.93 15.70 20.93L15.70 20.93ZM17.30 17.64Q17.93 17.64 18.12 17.03Q18.31 16.42 18.31 15.38L18.31 15.38L18.31 14.64L18.31 8.04Q18.31 7.27 18.10 6.74Q17.88 6.22 17.33 6.22L17.33 6.22Q16.70 6.22 16.50 6.71Q16.30 7.20 16.30 8.04L16.30 8.04L16.30 15.43Q16.30 17.64 17.30 17.64L17.30 17.64Z",
    transform: "translate(12 15.71)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 46.512,
    y1: 0,
    x2: 46.512,
    y2: "100%",
    stroke: "#ead017",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    color: "#000000",
    transform: "translate(60.012, 12) scale(0.6041667)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 47,
    x: 0,
    y: 0,
    viewBox: "0 0 48 47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M32.083 0l-.46.265-2.644 1.527-13.062 7.542L3.854 30.228.267 36.442l-.267.46 2.117 1.222 13.925 8.042.123.07H48V27.57l-.071-.124L34.953 4.97 32.083 0zM25.04 5.292l6.654-3.841 6.547 11.34-13.2-7.5zm-7.67 4.43l6.604-3.814 15.317 8.703 6.725 11.65-28.647-16.54zm-.531.92l29.566 17.07-29.566 17.07v-34.14zM9.171 40.97l-.123-17.615 6.728-11.65v33.078L9.17 40.97zm-7.72-4.457l6.547-11.338.107 15.18-6.654-3.842zm45.487-7.88v7.627l-15.194 8.912H18.29l28.648-16.54zm0 8.858v7.681H33.842l13.096-7.681zM23.567 22.294l9.384 5.42-9.384 5.417V22.294zm1.06 1.84v7.156l6.198-3.577-6.198-3.578z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo1);
export default __webpack_public_path__ + "static/media/logo1.cf2be0adfecb016b8ba083b91cf77063.svg";
export { ForwardRef as ReactComponent };